import React, { useState } from 'react';
import Warning from '../../../assets/icons/red-warning.svg';
import RightTick from '../../../assets/icons/right-tick.svg';
import {
  useGlobalActions,
  useGlobalContext,
} from '../../../global-context/GlobalContext';
import useIsMobile from '../../../hooks/utils/useIsMobile';
import {
  SpecialProduct,
  SupportedLanguage,
} from '../../../interfaces/ISpecialOrder';
import DrawerCommon from '../../common/drawer-common/DrawerCommon';
import ProductCard from '../product-card/ProductCard';
import QuantitySelector from '../quantity-selector/QuantitySelector';
import './FoodCard.scss';
import { useTolgee } from '@tolgee/react';

interface FoodCardProps {
  foodInfo: SpecialProduct;
  selectedDate: any;
}

const baseUrl = process.env.REACT_APP_BASE_URL_IMAGE;
const FoodCard: React.FC<FoodCardProps> = ({ foodInfo, selectedDate }) => {
  const quantity =
    useGlobalContext(c => c.specialOrder.cartItems).get(foodInfo.productId)
      ?.cartQuantity ?? 0;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isMobile = useIsMobile();

  const { getLanguage } = useTolgee();
  const language = getLanguage() as SupportedLanguage;

  const { handleProductName } = useGlobalActions();

  const { name: productName } = handleProductName(
    foodInfo.productNames,
    language,
  );

  return (
    <>
      <div className={`food-card ${isMobile ? 'mobile' : ''}`}>
        <div
          className='food-card__image-container'
          onClick={() => setIsDrawerOpen(true)}
        >
          <img
            src={`${baseUrl}${foodInfo.productImage}`}
            alt={productName}
            className='food-card__image'
          />
          {foodInfo.isAllergic && (
            <div className='food-card-allergy'>
              {foodInfo.allergicItems.map((allergy, index) => (
                <img
                  src={`${baseUrl}${allergy.image}`}
                  alt={allergy.name}
                  className='food-card-allergy__img'
                  key={index}
                />
              ))}
            </div>
          )}
          <div className='food-card__image-container-header left'>
            {Boolean(foodInfo.allergicItems.length) && <img src={Warning} />}
          </div>
          <div className='food-card__image-container-header right'>
            {quantity > 0 && <img src={RightTick} />}
          </div>
        </div>
        <div className='food-card__details'>
          <div className='food-card__details-info'>
            <h2
              className='food-card__title'
              onClick={() => setIsDrawerOpen(true)}
            >
              {productName}
            </h2>
            <p className='food-card__price'>CHF {foodInfo.price.toFixed(2)}</p>
            <div className='food-card__icons'>
              {foodInfo.productFeatures.map((info, index) => (
                <img
                  src={`${baseUrl}${info.image}`}
                  alt={info.name}
                  className='food-card__icons-img'
                  key={index}
                />
              ))}
            </div>
          </div>

          <QuantitySelector
            quantity={quantity}
            foodInfo={foodInfo}
            selectedDate={selectedDate}
          />
        </div>
      </div>

      <AddEditDetailsDrawer
        isOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        foodInfo={foodInfo}
      />
    </>
  );
};

const AddEditDetailsDrawer = ({ isOpen, foodInfo, setIsDrawerOpen }: any) => {
  const isMobile = useIsMobile();
  return (
    <DrawerCommon
      isVisible={isOpen}
      setVisibility={setIsDrawerOpen}
      placement='right'
      styles={{ width: isMobile ? '60%' : '30%', maxWidth: '50rem' }}
    >
      <ProductCard setIsDrawerOpen={setIsDrawerOpen} foodInfo={foodInfo} />
    </DrawerCommon>
  );
};

export default FoodCard;
